/**
 * Formats an array of numeric ids into the value expected by the backend for an
 * {@link Operation.In} condition.
 *
 * The backend/OData parser is strict about the separator: values MUST be separated by a
 * comma followed by a single space and wrapped in parentheses, e.g. `(1, 4)`. A value such
 * as `(1,4)` (missing the space) is NOT accepted. Always build `Operation.In` values through
 * this helper so the formatting is identical everywhere.
 *
 * @param ids numeric ids to include in the filter
 * @returns the formatted value, e.g. `(1, 4)` (or `()` for an empty array)
 */
export const formatInFilterValue = (ids: number[]): string => `(${ids.join(', ')})`;
